import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useNombreJugador from '../hooks/useNombreJugador';
import './Ranking.css';
import {
  getRankingParticipantesReal,
  getRankingJugadoresReal,
  getRankingClubesReal,
} from '../services/rankingsService';
import { useTemporada } from '../context/TemporadaContext';

const MODALIDADES = [
  'DOBLES FEMENINO', 'DOBLES MASCULINO', 'DOBLES MIXTO',
  'INDIVIDUAL FEMENINO', 'INDIVIDUAL MASCULINO',
];

const COLUMNAS_PARTICIPANTES = [
  ['nombre_mostrar', 'Equipo/Jugador'], ['jugados', 'J'], ['ganados', 'G'],
  ['perdidos', 'P'], ['sets_ganados', 'Sets'], ['tantos_totales', 'Tantos'], ['puntos', 'Puntos'],
];
const COLUMNAS_JUGADORES = [['nombre', 'Jugador'], ['jugados', 'J'], ['ganados', 'G'], ['puntos', 'Puntos']];
const COLUMNAS_CLUBES = [['club', 'Club'], ['jugadores', 'Jugadores'], ['participaciones', 'Participaciones'], ['puntos', 'Puntos']];

function Ranking() {
  const [porParticipantes, setPorParticipantes] = useState([]);
  const [porJugadores, setPorJugadores] = useState([]);
  const [porClubes, setPorClubes] = useState([]);
  const [openSection, setOpenSection] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const nombreDe = useNombreJugador();
  const { temporada } = useTemporada();
  const jugadoresPath = location.pathname.startsWith('/privado') ? '/privado/jugadores' : '/jugadores';

  useEffect(() => {
    if (!temporada) return;
    Promise.all([
      getRankingParticipantesReal(temporada),
      getRankingJugadoresReal(temporada),
      getRankingClubesReal(temporada),
    ])
      .then(([participantes, jugadores, clubes]) => {
        setPorParticipantes(participantes);
        setPorJugadores(jugadores);
        setPorClubes(clubes);
      })
      .catch(() => setError('No se pudo cargar el ranking. ¿Está el servidor en marcha?'));
  }, [temporada]);

  const toggleSection = (section) => setOpenSection(openSection === section ? null : section);

  const filtrar = (entries) => {
    const term = busqueda.trim().toLowerCase();
    if (!term) return entries;
    return entries.filter((e) => Object.values(e).some((v) => String(v).toLowerCase().includes(term)));
  };

  const renderTable = (entries, columnas, { clicable } = {}) => {
    if (!entries.length) return <p className="ranking-empty">No hay resultados</p>;
    return (
      <table>
        <thead className="sticky">
          <tr>{columnas.map(([, label]) => <th key={label}>{label}</th>)}</tr>
        </thead>
        <tbody>
          {entries.map((entry, i) => (
            <tr
              key={i}
              className={clicable ? 'clicable' : ''}
              onClick={clicable ? () => navigate(`${jugadoresPath}?id=${entry.jugador_id}`) : undefined}
            >
              {columnas.map(([campo]) => (
                <td className={campo === 'puntos' ? 'bold' : ''} key={campo}>{campo === 'nombre' ? nombreDe(entry) : entry[campo]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const buscando = busqueda.trim().length > 0;

  const secciones = [
    { key: 'JUGADORES', label: 'Individual (todas las modalidades)', entries: porJugadores, columnas: COLUMNAS_JUGADORES, clicable: true, oculta: true },
    ...MODALIDADES.map((mod) => ({
      key: mod,
      label: mod.charAt(0) + mod.slice(1).toLowerCase(),
      entries: porParticipantes.filter((e) => e.modalidad === mod),
      columnas: COLUMNAS_PARTICIPANTES,
    })),
    { key: 'CLUBES', label: 'Clubes', entries: porClubes, columnas: COLUMNAS_CLUBES, oculta: true },
  ].filter((s) => !s.oculta); // ocultas por ahora (no se borran): Individual (todas) y Clubes

  if (error) return <div className="ranking-page"><p className="msg-error">{error}</p></div>;

  return (
    <div className="ranking-page">
      <h2>Clasificación de temporada</h2>

      <div className="ranking-search">
        <input
          type="search"
          placeholder="Buscar..."
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          className="ranking-search-input"
        />
      </div>

      {secciones.map(({ key, label, entries, columnas, clicable }) => {
        const isOpen = buscando || openSection === key;
        return (
          <div key={key}>
            <button className="ranking-section-btn" onClick={() => toggleSection(key)}>
              {label}
            </button>
            {isOpen && (
              <div className="ranking-list">
                {renderTable(filtrar(entries), columnas, { clicable })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Ranking;
